// Latched "the server is a newer version than this bundle" signal. Lives outside React so the
// Apollo link, which cannot call hooks, can report into it. Both the response-header link and
// the periodic /api/version poll report here, so the prompt appears at most once.

type Listener = () => void;

let changed = false;
let listeners = new Set<Listener>();

export function reportServerVersion(version: string): void {
  if (changed || version === window.config.version) {
    return;
  }

  changed = true;
  listeners.forEach((listener) => listener());
}

export function subscribeToVersionChange(listener: Listener): () => void {
  listeners.add(listener);

  if (changed) {
    listener();
  }

  return () => {
    listeners.delete(listener);
  };
}

export function resetVersionSignalForTests(): void {
  changed = false;
  listeners = new Set<Listener>();
}
